// --- LAYOUT, COMPONENTS, PARTS --- //
$(function () {
    fn_layout_main();
    fn_layout_header();
    fn_comp_visual();
    fn_comp_reference();
    fn_comp_boxes();
    fn_comp_partners();
    fn_comp_featuring();
    fn_comp_map();
    fn_part_sidebar();
    fn_part_filter();
    fn_part_product();
    fn_part_product_info();
    fn_part_side_form();
    fn_comp_gallery();
    fn_part_qr();
    fn_part_ui_dialog();
    fn_comp_configurator();
});

// --- MISC --- //
$(function () {
    nl_fn_cookie();
    nl_fn_footer();
    nl_fn_check_size();
    nl_fn_anchor_link();
    nl_fn_scroll_to();
    nl_fn_check_size();
    $(window).scroll(nl_fn_scroll_to);
});

$(window).load(function(){
    if ($(window).width() > 1024 && $("body").hasClass("hp")) {
        window.sr = ScrollReveal();
        sr.reveal('[data-reveal]', {duration: 800, easing: 'ease-in-out'});
    }
});